<p-dialog
  [(visible)]="migrationService.visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
  styleClass="database-migration-dialog"
  [style]="{
    width: upgradeStatus() === UPGRADE_STATUS.PENDING ? '50vw' : '75vw',
    maxHeight: '90vh',
  }">
  <div class="tw:flex tw:flex-col tw:gap-3 tw:items-center">
    @if (upgradeStatus() === UPGRADE_STATUS.PENDING) {
      <div class="tw:font-bold tw:text-4xl">Database Migration Required</div>
      <div class="tw:text-center tw:font-bold">
        The database connected to the system appears to be stale.
      </div>
      @if (!showUpgradeButton()) {
        <div class="tw:text-center">
          Contact your administrator to resolve the issue so you can continue using the platform.
        </div>
      } @else {
        <div class="tw:text-center">
          The database schema needs to be updated to continue using the platform.
        </div>
        <div class="tw:text-center">Click the button below to upgrade the database.</div>
        @if (secureAdmin()) {
          <input
            test-id="database-migration-modal-admin-key"
            pInputText
            type="password"
            autocomplete="off"
            class="tw:w-72"
            placeholder="Admin key"
            aria-label="Admin key"
            [ngModel]="adminKey()"
            (ngModelChange)="adminKey.set($event)"
            (keydown.enter)="adminKey() && startUpgrade()" />
        }
        <p-message
          severity="error"
          [closable]="false"
          styleClass="tw:mt-3 tw:text-center">
          <strong>WARNING! This is an irreversible action.</strong>
          <br />
          Errors that occur during migration might cause the system to become unstable
        </p-message>
      }
    } @else if (upgradeStatus() === UPGRADE_STATUS.IN_PROGRESS) {
      <div class="tw:font-bold tw:text-3xl">Database Upgrade in Progress</div>
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }" />
      <div
        role="status"
        class="tw:text-center">
        Database upgrade in progress. Please wait…
      </div>
    } @else if (upgradeStatus() === UPGRADE_STATUS.SUCCESS) {
      <div class="tw:font-bold tw:text-4xl">Upgrade Successful</div>
      <div class="tw:text-center">
        Database upgrade completed successfully. Click "Continue to Platform" to proceed.
      </div>
    } @else if (upgradeStatus() === UPGRADE_STATUS.ERROR) {
      <div class="tw:font-bold tw:text-4xl">Upgrade Failed</div>
      <div class="tw:text-center">
        Database upgrade failed. Please check the logs for details and contact your administrator.
      </div>
      @if (upgradeError()) {
        <div class="tw:text-center tw:text-muted-color tw:text-sm">
          {{ upgradeError() }}
        </div>
      }
    }

    @if (logs().length > 0) {
      <div class="tw:w-full">
        <div class="tw:flex tw:justify-between tw:items-center tw:mb-2">
          Upgrade Logs
          <p-button
            test-id="database-migration-modal-copy-logs"
            [buttonProps]="{ autofocus: false }"
            label="Copy Logs"
            icon="pi pi-copy"
            [outlined]="true"
            size="small"
            (onClick)="copyLogs()"
            [disabled]="logs().length === 0" />
        </div>
        <div
          class="logs-container"
          #logsContainer>
          @for (log of logs(); track $index) {
            <div class="log-line tw:text-sm">{{ log }}</div>
          }
        </div>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="tw:flex tw:flex-auto tw:justify-center">
      @if (upgradeStatus() === UPGRADE_STATUS.PENDING) {
        @if (showUpgradeButton()) {
          <p-button
            test-id="database-migration-modal-start-database-upgrade"
            [buttonProps]="{ autofocus: false }"
            icon="pi pi-database"
            severity="danger"
            variant="outlined"
            label="Start Database Upgrade"
            [disabled]="secureAdmin() && !adminKey()"
            (click)="startUpgrade()" />
        } @else {
          <p-button
            test-id="database-migration-modal-im-administrator"
            class="admin-reveal"
            [buttonProps]="{ autofocus: false }"
            label="I'm the administrator"
            severity="secondary"
            variant="text"
            size="small"
            (onClick)="showUpgradeButton.set(true)" />
        }
      } @else if (upgradeStatus() === UPGRADE_STATUS.SUCCESS) {
        <p-button
          test-id="database-migration-modal-continue-to-ggx"
          [buttonProps]="{ autofocus: false }"
          icon="pi pi-arrow-right"
          label="Continue to GGX"
          (click)="continueToPlatform()" />
      } @else if (upgradeStatus() === UPGRADE_STATUS.ERROR) {
        <p-button
          test-id="database-migration-modal-close"
          [buttonProps]="{ autofocus: false }"
          icon="pi pi-times"
          label="Close"
          (click)="onClose()"
          severity="secondary" />
      }
    </div>
  </ng-template>
</p-dialog>
